import { render, staticRenderFns } from "./tokens.vue?vue&type=template&id=7f8b4fee&scoped=true&"
import script from "./tokens.vue?vue&type=script&lang=js&"
export * from "./tokens.vue?vue&type=script&lang=js&"
import style0 from "./tokens.vue?vue&type=style&index=0&id=7f8b4fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b4fee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8b4fee')) {
      api.createRecord('7f8b4fee', component.options)
    } else {
      api.reload('7f8b4fee', component.options)
    }
    module.hot.accept("./tokens.vue?vue&type=template&id=7f8b4fee&scoped=true&", function () {
      api.rerender('7f8b4fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/apps/tokens.vue"
export default component.exports